import { useCallback } from 'react';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';
import {
  ReferralsEventLabels,
  ReferralsEventMap,
  type TrackReferralsEvent,
} from './events';

/**
 * Custom hook to handle referrals tracking events
 */
export function useTrackReferralsAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackReferralsEvent, extra?: Record<string, unknown>) => {
      const eventLabel = ReferralsEventLabels[event];
      const eventInfo = ReferralsEventMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
